/**
 * Validation result object returned by validation functions.
 */
export class ValidationFunctionResult {
	errors?: string[];
	isValid!: boolean;
}
